import { palette, mediaQueries, Button } from '@centivo/react-components'
import styled, { css } from 'styled-components'

export const FilterButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  width: min-content;
  height: min-content;
  padding: 0.375rem 0.5rem !important;
  margin-left: auto;

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          color: ${palette.brand.darkPurple} !important;
          font-weight: 500;
          border-radius: 5px;
          background-color: #ebeff5;
          border: 1px solid transparent;

          &:hover {
            background-color: ${palette.brand.lightPurple};
            box-shadow: none !important;
          }

          &:focus {
            background-color: ${palette.brand.lightPurple} !important;
            border: 1px solid ${palette.brand.newPurple};
          }
        `
      default:
        return css`
          color: ${palette.neutral['grey-icons']} !important;
          fontweight: 600;
          border-color: ${palette.neutral['grey-bbbdbf']} !important;

          &:hover {
            background-color: ${palette.neutral['grey-ebebeb']};
            box-shadow: none !important;
          }

          &:focus {
            background-color: ${palette.ui.blueBg} !important;
          }
        `
    }
  }}

  @media ${mediaQueries.mobile} {
    margin-left: unset;
  }

  @media ${mediaQueries.desktop} {
    grid-column: 2;
    grid-row: 1;
    margin: 0;
  }

  svg {
    margin-left: 0.5rem;
  }
`
FilterButton.defaultProps = {
  buttonType: 'secondary',
  edgeType: 'rounded',
  slim: true,
}
